import axios from 'axios';

const BRAVO_ENDPOINT = 'https://manager.bravohub.app/api/ci/external-gamification/29af6c9d-2c40-407d-8616-14c93f3f2dc1';
const VERIFY_ENDPOINT = "https://manager.bravohub.app/api/ci/somosguararapes/verify-user";

export async function verifyUser(email) {
  try {
    const { data } = await axios.get(`${VERIFY_ENDPOINT}?email=${email}`);
    return data && data.status === "success";
  } catch (error) {
    console.error("Erro ao verificar usuário:", error);
    return false;
  }
}

export async function bravoRequest(data) {
  try {
    await axios.post(BRAVO_ENDPOINT, data);
    return true;
  } catch (error) {
    console.error("Erro ao enviar requisição para o Bravo:", error);
    return false;
  }
}